import {
    InquiryCategoryCount,
    InquiryFetchArgs,
    getInquiryCategoryCounts,
  } from '../../assets/ts/data/inquiry/inquiry'
  import useServerData from '../use-server-data'
  
  function useInquiryCategoryCounts(fetchArgs: InquiryFetchArgs) {
    const {
      data: inquiryCount,
      error: inquiryCountError,
      fetchData: fetchInquiryCount,
      isLoading: inquiryCountIsLoading,
  
    } = useServerData<InquiryCategoryCount, InquiryFetchArgs>(
      getInquiryCategoryCounts,
      fetchArgs
    )
  
    return {
      fetchInquiryCount,
      inquiryCount, // retained for backward-compatibility.  Use inquiryCountValue
      inquiryCountError,
      inquiryCountIsLoading
    }
  }
  
  export default useInquiryCategoryCounts
  